module.exports = __webpack_public_path__ + "static/media/Gerald R. Ford (I) - 1976.1b69a1c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Gerald R. Ford (I) - 1976.jpg
// module id = 479
// module chunks = 0